import { render, staticRenderFns } from "./notice-add-and-update.vue?vue&type=template&id=31fb1f39"
import script from "./notice-add-and-update.vue?vue&type=script&lang=js"
export * from "./notice-add-and-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31fb1f39')) {
      api.createRecord('31fb1f39', component.options)
    } else {
      api.reload('31fb1f39', component.options)
    }
    module.hot.accept("./notice-add-and-update.vue?vue&type=template&id=31fb1f39", function () {
      api.rerender('31fb1f39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/notice/notice-add-and-update.vue"
export default component.exports